import React, { useState } from "react";
import DialogComponent from "../../../components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import Button from "src/components/Button";
import { updateItem, deleteItem, addItem } from "src/modules/spItems/actions";
import Loading from "src/components/Loading";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "src/api/requests/updateFile";
import {
  approversCardDocumentListName,
  approversDependenciesListName,
  approversListName,
  documentByCardFilesLibName,
  emailsSender,
  equipmentsByDocumentListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  MDDocumentsFiles,
  MDWorkstationListName,
  myDocumentsListName,
  myWorksDocumentsListName,
  paramsListName,
  siteUrl,
  versionsByDocumentListName,
} from "src/api/config";
import { selectItems, selectItem } from "src/modules/spItems/selectors";
import _ from "lodash";
import moment from "moment";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import {
  addItemRequest,
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import { getWorkDocumentsInfo } from "../documents/actions";
import { useNavigate } from "react-router-dom";
import { emailAPI } from "src/utils/api.utils";
import { checkApprovers, setMultiApprove } from "../constants";
import { notificationIdsListName, notificationsCardListName, notificationsListName } from "src/api/config/notifications.config";
import { emailQueueListName } from "src/api/config/email.config";
import {
  docApprovers,
  docStatuses,
  notificationStatuses,
} from "src/api/config/systemSwitch";
const { sendEmail } = emailAPI();

type Props = {
  open: boolean;
  dialogToggle: any;
  dataSend: any;
  setOpen: any;
  removeObjData: any;
  versionView: any;
  setCustomLoading: any;
};

const ConfirmChangeStatusCardModal = (props: Props) => {
  const {
    open,
    dialogToggle,
    dataSend,
    setOpen,
    removeObjData,
    versionView,
  } = props;
  const dispatch = useAppDispatch();
  const [confirm, setConfirm] = useState(false);
  const [comment, setComment] = useState("");
  const currentUser = useAppSelector(selectCurrentUser);
  const users: any = useAppSelector(selectUsers);
  const navigate = useNavigate();
  const card = dataSend['card'];
  const approversList = dataSend['approversList'];
  const repeatEmails: any = useAppSelector((state) => selectItems(state, paramsListName));
  const approversDependencies = dataSend['approversDependencies'];

  const sendDataHandle = (type: string) => {
    dataSend.setLoading();
    let requests: any = [];

    // обновим частично множественное согласование
    if (dataSend["updateCurrentGroupMultiApproved"]) {
      if (dataSend["updateCurrentGroupMultiApproved"]) {
        requests.push(updateItemRequest({
          listName: approversCardDocumentListName,
          body: dataSend["updateCurrentGroupMultiApproved"]
        }));
      }
    }

    if (
      dataSend["notificationsRemove"] &&
      dataSend["notificationsRemove"].length > 0
    ) {
      requests = [...requests, deleteItemRequest({ listName: notificationsListName, ID: 0, Ids: dataSend["notificationsRemove"] })]
    }
    if (dataSend["emailsRemove"] && dataSend["emailsRemove"].length > 0) {
      requests = [...requests, deleteItemRequest({ listName: emailQueueListName, ID: 0, Ids: dataSend["emailsRemove"] })]
    }
    if (
      dataSend["historyCardRemove"] &&
      dataSend["historyCardRemove"].length > 0
    ) {
      requests = [...requests, deleteItemRequest({ listName: historyByDocumentListName, ID: 0, Ids: dataSend["historyCardRemove"] })]
    }
    if (dataSend["emailBody"] && Object.keys(dataSend["emailBody"]).length > 0) {
      requests = [...requests, sendEmail(dataSend["emailBody"])];
    }
    if (dataSend["emailsBody"] && dataSend["emailsBody"].length > 0) {
      let emailsHanleArr: any = [];
      dataSend["emailsBody"].forEach((item: any) => {
        emailsHanleArr = [...emailsHanleArr, sendEmail(item)];
      });
      if (emailsHanleArr.length > 0) {
        requests = [...requests, ...emailsHanleArr];
      }
    }

    if (type !== "draft") {
      if (dataSend["updateCard"] && dataSend["updateCard"]["EquipmentsListNew"] && dataSend["updateCard"]["EquipmentsListNew"].length > 0) {
        let sendDataEquipments: any = [];
        for (
          let i = 0;
          i < dataSend["updateCard"]["EquipmentsListNew"].length;
          i++
        ) {
          sendDataEquipments = [
            ...sendDataEquipments,
            {
              Title: `Document card #${dataSend["updateCard"]["ID"]}`,
              Line:
                dataSend["updateCard"]["EquipmentsListNew"][i]["Line"] &&
                dataSend["updateCard"]["EquipmentsListNew"][i]["Line"]["id"],
              Equipment:
                dataSend["updateCard"]["EquipmentsListNew"][i]["SAP"] &&
                dataSend["updateCard"]["EquipmentsListNew"][i]["SAP"]["ID"],
              Document: dataSend["updateCard"]["ID"],
              VersionDocument: (versionView && true) || false,
            },
          ];
        }
        if (sendDataEquipments.length > 0) {
          requests = [...requests, addItemRequest({ listName: equipmentsByDocumentListName, body: sendDataEquipments[0], bodyArr: sendDataEquipments })];
        }
        if (
          dataSend["updateCard"]["EquipmentsListOld"] &&
          dataSend["updateCard"]["EquipmentsListOld"].length > 0
        ) {
          let removeIds: any = [];
          for (
            let i = 0;
            i < dataSend["updateCard"]["EquipmentsListOld"].length;
            i++
          ) {
            if (
              removeObjData &&
              removeObjData.length > 0 &&
              removeObjData.filter(
                (item: any) =>
                  item.listName === equipmentsByDocumentListName &&
                  item.ID ===
                  dataSend["updateCard"]["EquipmentsListOld"][i]["ID"]
              ).length === 0
            ) {
              removeIds = [
                ...removeIds,
                {
                  ID: dataSend["updateCard"]["EquipmentsListOld"][i]["ID"],
                },
              ];
            }
          }
          if (removeIds.length > 0) {
            requests = [...requests, deleteItemRequest({ listName: equipmentsByDocumentListName, ID: 0, Ids: removeIds })];
          }
        }
        delete dataSend["updateCard"]["EquipmentsListOld"];
        delete dataSend["updateCard"]["EquipmentsListNew"];
      }
      if (dataSend["updateCard"] && dataSend["updateCard"]["File"]) {
        requests = [...requests, uploadFile(
          dataSend["updateCard"]["File"],
          documentByCardFilesLibName,
          MDDocumentsFiles.idFolder,
          MDDocumentsFiles.apiStrapi,
          MDDocumentsFiles.createElemInStrapi,
          card.Title
        ).then((objUploadFile: any) => {
          return updateFile(
            documentByCardFilesLibName,
            {
              CardID: dataSend["updateCard"].ID,
              ID: objUploadFile["id"],
              VersionDocument: (versionView && true) || false,
            },
            MDDocumentsFiles.apiStrapi,
            {
              CardID: dataSend["updateCard"].ID,
              id: objUploadFile["id"],
              VersionDocument: (versionView && true) || false,
            }
          );
        })]
        delete dataSend["updateCard"]["File"];
      }
      if (type === "reject" || type === "modification") {
        if (dataSend["preventGroup"]) {
          requests = [...requests, updateItemRequest({ listName: approversCardDocumentListName, body: dataSend["preventGroup"] })];
        }
        if (dataSend["historyCardAdd"]) {
          dataSend["historyCardAdd"]["Comment"] = comment;
          requests = [...requests, addItemRequest({ listName: historyByDocumentListName, body: dataSend["historyCardAdd"] })];
        }
        if (dataSend["historyFieldsCardAdd"]) {
          dataSend["historyFieldsCardAdd"]["Comment"] = comment;
          requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: dataSend["historyFieldsCardAdd"] })];
        }
        if (
          dataSend["notificationData"] &&
          dataSend["notificationData"].length > 0
        ) {
          dataSend["notificationData"].forEach((item: any, idx: number) => {
            dataSend["notificationData"][idx]["AuthorComment"] = comment;
          });
          requests = [...requests, addItemRequest({ listName: notificationsListName, body: dataSend["notificationData"][0], bodyArr: dataSend["notificationData"] })];
        }
        requests = [...requests, updateItemRequest({ listName: (versionView && versionsByDocumentListName) || myDocumentsListName, body: dataSend["updateCard"] })];
        if (emailsSender) {
          const emailBody = {
            Body: `Здравствуйте ${users[card.AuthorEmail.toLowerCase()] &&
              users[card.AuthorEmail.toLowerCase()]["displayName"]
              },<br/><br/>${(type === "reject" &&
                "Уведомляем Вас, что следующий документ был отклонен") ||
              "Уведомляем Вас, что следующий документ был отправлен на доработку"
              }:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${versionView && card.MainDocument.get_lookupId() || card.ID}${(versionView && `&version=${versionView}`) || ""
              }">${card.Title
              }</a><br/><br/>Комментарий от согласующего ${currentUser.displayName
              }: ${comment}`,
            DateToBeSentAt: moment().subtract(12, "hours").toDate(),
            Title:
              (type === "reject" && "Мои Документы | Отклонение документа") ||
              "Мои Документы | Отправка на доработку документа",
            Subject:
              (type === "reject" && "Мои Документы | Отклонение документа") ||
              "Мои Документы | Отправка на доработку документа",
            Recepients: card.AuthorEmail.toLowerCase(),
            CheckDoc: String(versionView && card.MainDocument.get_lookupId() || card.ID),
          };
          requests = [...requests, sendEmail(emailBody)];
        }
      }
      if (type === "agreement") {
        requests = [...requests, deleteItemRequest({
          listName: approversCardDocumentListName, ID: 0, Ids: dataSend['approversByDocument'].map((approver: any) => {
            return { ID: approver.ID }
          })
        })];
        let dataApproversCard: any = [], dataNotificationCard: any = [];
        dataApproversCard = [
          ...dataApproversCard,
          {
            Title: `Approver card # ${card.ID}`,
            Approvers: [currentUser.email],
            Document: card.ID,
            order: 0,
            Group: docApprovers.Creater,
            Statuses: [docStatuses.edited, docStatuses.sendApproval],
            VersionDocument: versionView && true || false
          },
        ];
        Object.keys(dataSend['new_approvers']).map((key: string, idx: number) => {
          const people: { avatar: string; label: string; value: string }[] =
            (Array.isArray(dataSend['new_approvers'][key]) &&
              dataSend['new_approvers'][key].length > 0 &&
              dataSend['new_approvers'][key]) ||
            [];
          let sendPeople: string[] = [];
          people.map((user) => {
            if (user.value) {
              sendPeople = [...sendPeople, user.value.toLowerCase()];
            }
          });
          const groupID =
            approversList.filter((item: any) => item.Code === key).length > 0 &&
            approversList.filter((item: any) => item.Code === key)[0]["ID"];
          const order =
            (approversList.filter((item: any) => item.Code === key).length > 0 &&
              approversList.filter((item: any) => item.Code === key)[0][
              "SortColumn"
              ]) ||
            0;
          if (checkApprovers(groupID, approversDependencies)) {
            sendPeople.forEach((email: any) => {
              dataNotificationCard = [
                ...dataNotificationCard,
                {
                  Title: `Согласовать # ${card.ID}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        repeatEmails
                          .find(
                            (param: any) => param.Key === "documentsApproveDays"
                          )
                        ["Value"].trim()
                      ),
                      "days"
                    )
                    .toDate(),
                  AuthorComment: comment,
                  DocumentCode: `${card.Code}.${card.Index}`,
                  Document: versionView && card.MainDocument.get_lookupId() || card.ID,
                  NotificationType: notificationStatuses.approval, // Согласовать
                  Employee: email.toLowerCase(),
                  EmployeeEmail: email.toLowerCase(),
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                  VersionDocument: versionView && card.ID || null
                }
              ];
            });
            if (emailsSender) {
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim()
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                sendPeople.forEach((email: any) => {
                  const emailBody = {
                    Body: `Здравствуйте ${users[email.toLowerCase()] &&
                      users[email.toLowerCase()]["displayName"]
                      },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${versionView && card.MainDocument.get_lookupId() || card.ID}${versionView && `&version=${card.ID} || ""`}">${card.Title}</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                      }>${moment(new Date())
                        .add(
                          Number(
                            repeatEmails
                              .find(
                                (param: any) =>
                                  param.Key === "documentsApproveDays"
                              )
                            ["Value"].trim()
                          ),
                          "days"
                        )
                        .format("DD.MM.YYYY")}</span>`,
                    DateToBeSentAt: date,
                    Title: "Мои Документы | Согласование документа",
                    Subject: "Мои Документы | Согласование документа",
                    Recepients: email,
                    CheckDoc: String(versionView && card.MainDocument.get_lookupId() || card.ID),
                    RepeatAt: (idxDate === 1 && minutes) || 0,
                  };
                  emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                });
              });
              requests = [...requests, ...emailsHanleArr];
            }
          }
          dataApproversCard = [
            ...dataApproversCard,
            {
              Title: `Approver card # ${card.ID}`,
              Approvers: sendPeople,
              order: order,
              Document: card.ID,
              Group: groupID,
              Statuses: [docStatuses.waitApproval],
              Queue: checkApprovers(groupID, approversDependencies),
              MultiApprove: setMultiApprove(groupID, approversDependencies),
              VersionDocument: versionView && true || false
            },
          ];
          dataSend['historyCardAdd'] = [
            ...dataSend['historyCardAdd'],
            {
              Title: `History card # ${card.ID}`,
              Comment: "",
              order: order,
              Approvers: sendPeople,
              DocumentID: card.ID,
              ApprovalGroup: groupID,
              Statuses: [docStatuses.waitApproval],
              VersionDocument: versionView && true || false
            },
          ];
          dataApproversCard.sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          dataSend['historyCardAdd'].sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          dataSend['historyCardAdd'] = dataSend['historyCardAdd'].map((item: any) => {
            delete item.order;
            return { ...item };
          });

          dataApproversCard = dataApproversCard.map((item: any) => {
            delete item.order;
            return { ...item };
          });
        });
        requests = [...requests, ...[
          addItemRequest({
            listName: approversCardDocumentListName,
            bodyArr: dataApproversCard,
            body: dataApproversCard[0],
          }),
          addItemRequest({
            listName: historyChangeFieldsDocumentListName,
            body: dataSend['historyFieldsCardAdd'],
          }),
          addItemRequest({
            listName: historyByDocumentListName,
            body: dataSend['historyCardAdd'][0],
            bodyArr: dataSend['historyCardAdd'],
          }),
          addItemRequest({
            listName: notificationsListName,
            body: dataNotificationCard[0],
            bodyArr: dataNotificationCard,
          }),
          updateItemRequest({ listName: (versionView && versionsByDocumentListName) || myDocumentsListName, body: dataSend["updateCard"] })
        ]];
      }
      if (type === "approve") {
        if (dataSend["historyCardUpdate"]) {
          dataSend["historyCardUpdate"]["Comment"] = comment;
          requests = [...requests, updateItemRequest({ listName: historyByDocumentListName, body: dataSend["historyCardUpdate"] })];
        }
        if (dataSend["historyFieldsCardAdd"]) {
          dataSend["historyFieldsCardAdd"]["Comment"] = comment;
          requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: dataSend["historyFieldsCardAdd"] })];
        }
        if (
          dataSend["notificationData"] &&
          dataSend["notificationData"].length > 0
        ) {
          dataSend["notificationData"].forEach((item: any, idx: number) => {
            dataSend["notificationData"][idx]["AuthorComment"] = comment;
          });
          requests = [...requests, addItemRequest({ listName: notificationsListName, body: dataSend["notificationData"][0], bodyArr: dataSend["notificationData"] })];
        }
        if (dataSend["nextGroup"]) {
          requests = [...requests, updateItemRequest({ listName: approversCardDocumentListName, body: dataSend["preventGroup"], bodyArr: [dataSend["preventGroup"], dataSend["nextGroup"]] })];
        } else {
          if (
            dataSend["removeItemsApproversCardDocument"] &&
            dataSend["removeItemsApproversCardDocument"].length > 0
          ) {
            requests = [...requests, deleteItemRequest({ listName: approversCardDocumentListName, ID: 0, Ids: dataSend["removeItemsApproversCardDocument"] })];
          }
        }
        requests = [...requests, updateItemRequest({ listName: (versionView && versionsByDocumentListName) || myDocumentsListName, body: dataSend["updateCard"] })];
        if (!dataSend["nextGroup"] && versionView) {
          Promise.all(requests).then(values => {
            requests = [];
            Promise.all([
              getItemsRequest({
                listName: documentByCardFilesLibName,
                filters: { CardID: card.MainDocument.get_lookupId(), VersionDocument: false },
              }),
              getItemsRequest({
                listName: approversCardDocumentListName,
                filters: { Document: card.MainDocument.get_lookupId(), VersionDocument: false },
              }),
              getItemsRequest({
                listName: equipmentsByDocumentListName,
                filters: { Document: card.MainDocument.get_lookupId(), VersionDocument: false },
              }),
              getItemsRequest({
                listName: historyByDocumentListName,
                filters: { DocumentID: card.MainDocument.get_lookupId(), VersionDocument: false },
              }),
              getItemsRequest({
                listName: historyChangeFieldsDocumentListName,
                filters: { DocumentID: card.MainDocument.get_lookupId(), VersionDocument: false },
              }),
              getItemsRequest({
                listName: myDocumentsListName,
                filters: { ID: card.MainDocument.get_lookupId() },
              }),
              getItemsRequest({
                listName: notificationsListName,
                filters: { Document: card.MainDocument.get_lookupId(), VersionDocument: null },
              }),
              getItemsRequest({
                listName: versionsByDocumentListName,
                filters: { MainDocument: card.ID },
              }),
              getItemsRequest({
                listName: documentByCardFilesLibName,
                filters: { CardID: card.ID, VersionDocument: true },
              }),
              getItemsRequest({
                listName: approversCardDocumentListName,
                filters: { Document: card.ID, VersionDocument: true },
              }),
              getItemsRequest({
                listName: equipmentsByDocumentListName,
                filters: { Document: card.ID, VersionDocument: true },
              }),
              getItemsRequest({
                listName: historyByDocumentListName,
                filters: { DocumentID: card.ID, VersionDocument: true },
              }),
              getItemsRequest({
                listName: historyChangeFieldsDocumentListName,
                filters: { DocumentID: card.ID, VersionDocument: true },
              }),
              getItemsRequest({
                listName: notificationsListName,
                filters: { Document: card.MainDocument.get_lookupId(), VersionDocument: card.ID },
              }),
              getItemsRequest({
                listName: emailQueueListName,
                filters: { CheckDoc: String(card.MainDocument.get_lookupId()) },
              }),
            ]).then((results: any) => {
              const documentsMainCard: any = results[0].items;
              const approversMainCard: any = results[1].items;
              const equipmentsMainCard: any = results[2].items;
              const historyMainCard: any = results[3].items;
              const historyFieldsMainCard: any = results[4].items;
              const mainCard: any = results[5].items[0];
              const notificationsMainCard: any = results[6].items;
              //Нам нужно поменять основу на версию
              const version: any = results[7].items[0];
              const documentsVersionCard: any = results[8].items;
              const approversVersionCard: any = results[9].items;
              const equipmentsVersionCard: any = results[10].items;
              const historyVersionCard: any = results[11].items;
              const historyFieldsVersionCard: any = results[12].items;
              const notificationsVersionCard: any = results[13].items;
              const emailsMainCard: any = results[14].items;

              // Меняем привязку файлов основы на версию
              let requestsUpdate: any = [];
              if (documentsMainCard.length > 0) {
                let documentsMainCardUpdate: any = [];
                documentsMainCard.forEach((document: any) => {
                  documentsMainCardUpdate = [
                    ...documentsMainCardUpdate,
                    {
                      ID: document.ID,
                      VersionDocument: true,
                      CardID: version.ID,
                    },
                  ];
                });
                requestsUpdate = [
                  ...requestsUpdate,
                  updateItemRequest({
                    listName: documentByCardFilesLibName,
                    body: { ID: 0 },
                    bodyArr: documentsMainCardUpdate,
                  }),
                ];
              }
              // Удаляем все элементы из списка почты для основного дока
              if (emailsMainCard.length > 0) {
                let emailsCardRemove: any = [];
                emailsCardRemove.forEach((email: any) => {
                  emailsCardRemove = [
                    ...emailsCardRemove,
                    {
                      ID: email.ID,
                    },
                  ];
                });
                if (emailsCardRemove.length > 0) {
                  requestsUpdate = [
                    ...requestsUpdate,
                    deleteItemRequest({
                      listName: emailQueueListName,
                      ID: 0,
                      Ids: emailsCardRemove,
                    }),
                  ];
                }
              }
              // Удаляем все элементы из списка согласовантов для основного дока
              if (approversMainCard.length > 0) {
                let approversCardUpdate: any = [];
                approversMainCard.forEach((approvers: any) => {
                  approversCardUpdate = [
                    ...approversCardUpdate,
                    {
                      ID: approvers.ID,
                    },
                  ];
                });
                if (approversCardUpdate.length > 0) {
                  requestsUpdate = [
                    ...requestsUpdate,
                    deleteItemRequest({
                      listName: approversCardDocumentListName,
                      ID: 0,
                      Ids: approversCardUpdate,
                    }),
                  ];
                }
              }
              // Меняем привязку оборудования основы на версию
              if (equipmentsMainCard.length > 0) {
                let equipmentsCardUpdate: any = [];
                equipmentsMainCard.forEach((equipments: any) => {
                  equipmentsCardUpdate = [
                    ...equipmentsCardUpdate,
                    {
                      ID: equipments.ID,
                      VersionDocument: true,
                      Document: version.ID,
                    },
                  ];
                });
                requestsUpdate = [
                  ...requestsUpdate,
                  updateItemRequest({
                    listName: equipmentsByDocumentListName,
                    body: { ID: 0 },
                    bodyArr: equipmentsCardUpdate,
                  }),
                ];
              }
              // Меняем привязку истории согласующих основы на версию
              if (historyMainCard.length > 0) {
                let historyCardUpdate: any = [];
                historyMainCard.forEach((history: any) => {
                  historyCardUpdate = [
                    ...historyCardUpdate,
                    {
                      ID: history.ID,
                      VersionDocument: true,
                      DocumentID: version.ID,
                    },
                  ];
                });
                requestsUpdate = [
                  ...requestsUpdate,
                  updateItemRequest({
                    listName: historyByDocumentListName,
                    body: { ID: 0 },
                    bodyArr: historyCardUpdate,
                  }),
                ];
              }
              // Меняем привязку истории основы на версию
              if (historyFieldsMainCard.length > 0) {
                let historyFieldsCardUpdate: any = [];
                historyFieldsMainCard.forEach((history: any) => {
                  historyFieldsCardUpdate = [
                    ...historyFieldsCardUpdate,
                    {
                      ID: history.ID,
                      VersionDocument: true,
                      DocumentID: version.ID,
                    },
                  ];
                });
                requestsUpdate = [
                  ...requestsUpdate,
                  updateItemRequest({
                    listName: historyChangeFieldsDocumentListName,
                    body: { ID: 0 },
                    bodyArr: historyFieldsCardUpdate,
                  }),
                ];
              }
              // Меняем привязку уведомлений основы на версию
              if (notificationsMainCard.length > 0) {
                let notificationsCardUpdate: any = [];
                notificationsMainCard.forEach((notification: any) => {
                  notificationsCardUpdate = [
                    ...notificationsCardUpdate,
                    {
                      ID: notification.ID,
                      VersionDocument: version.ID,
                    },
                  ];
                });
                requestsUpdate = [
                  ...requestsUpdate,
                  updateItemRequest({
                    listName: notificationsListName,
                    body: { ID: 0 },
                    bodyArr: notificationsCardUpdate,
                  }),
                ];
              }
              requestsUpdate = [
                ...requestsUpdate,
                updateItemRequest({
                  listName: versionsByDocumentListName,
                  bodyArr: [
                    {
                      ID: version.ID,
                      Code: mainCard.Code,
                      Index: mainCard.Index,
                      Path: mainCard.Path,
                      Title: mainCard.Title,
                      Equipments: mainCard.Equipments,
                      Lines: mainCard.Lines,
                      Collection: mainCard.Collection.get_lookupId(),
                      Critical: mainCard.Critical,
                      DateForRevision: mainCard.DateForRevision,
                      Department: mainCard.Department.get_lookupId(),
                      DocType: mainCard.DocType.get_lookupId(),
                      Process: mainCard.Process.get_lookupId(),
                      PublicationDate: mainCard.PublicationDate,
                      ResponsibleForRevision:
                        mainCard.ResponsibleForRevision.get_email(),
                      Sector: mainCard.Sector.get_lookupId(),
                      Status: mainCard.Status.get_lookupId(),
                      AuthorEmail: mainCard.AuthorEmail.toLowerCase(),
                      ResponsibleForRevisionEmail:
                        mainCard.ResponsibleForRevisionEmail.toLowerCase(),
                      Ver: mainCard.Ver,
                      WorkPlaces: mainCard.WorkPlaces && mainCard.WorkPlaces.length > 0 && mainCard.WorkPlaces.map(place => place.get_lookupId()) || [],
                      Created: mainCard.Created
                    },
                  ],
                  body: { ID: 0 },
                }),
              ];
              Promise.all(requestsUpdate).then((results: any) => {
                requestsUpdate = [];
                let versionByMainArr: any = [];
                //Нам нужно поменять версию на основу
                // Меняем привязку файлов версии на основу
                if (documentsVersionCard.length > 0) {
                  let documentsMainCardUpdate: any = [];
                  documentsVersionCard.forEach((document: any) => {
                    documentsMainCardUpdate = [
                      ...documentsMainCardUpdate,
                      {
                        ID: document.ID,
                        VersionDocument: false,
                        CardID: mainCard.ID,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: documentByCardFilesLibName,
                      body: { ID: 0 },
                      bodyArr: documentsMainCardUpdate,
                    }),
                  ];
                }
                // Меняем привязлу согласующих версии на основу
                if (approversVersionCard.length > 0) {
                  let approversCardUpdate: any = [];
                  approversVersionCard.forEach((approvers: any) => {
                    approversCardUpdate = [
                      ...approversCardUpdate,
                      {
                        ID: approvers.ID,
                        VersionDocument: false,
                        Document: mainCard.ID,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: approversCardDocumentListName,
                      body: { ID: 0 },
                      bodyArr: approversCardUpdate,
                    }),
                  ];
                }
                // Меняем привязку оборудования версии на основу
                if (equipmentsVersionCard.length > 0) {
                  let equipmentsCardUpdate: any = [];
                  equipmentsVersionCard.forEach((equipments: any) => {
                    equipmentsCardUpdate = [
                      ...equipmentsCardUpdate,
                      {
                        ID: equipments.ID,
                        VersionDocument: false,
                        Document: mainCard.ID,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: equipmentsByDocumentListName,
                      body: { ID: 0 },
                      bodyArr: equipmentsCardUpdate,
                    }),
                  ];
                }
                // Меняем привязку истории согласующих версии на основу
                if (historyVersionCard.length > 0) {
                  let historyCardUpdate: any = [];
                  historyVersionCard.forEach((history: any) => {
                    historyCardUpdate = [
                      ...historyCardUpdate,
                      {
                        ID: history.ID,
                        VersionDocument: false,
                        DocumentID: mainCard.ID,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: historyByDocumentListName,
                      body: { ID: 0 },
                      bodyArr: historyCardUpdate,
                    }),
                  ];
                }
                // Меняем привязку истории версии на основу
                if (historyFieldsVersionCard.length > 0) {
                  let historyFieldsCardUpdate: any = [];
                  historyFieldsVersionCard.forEach((history: any) => {
                    historyFieldsCardUpdate = [
                      ...historyFieldsCardUpdate,
                      {
                        ID: history.ID,
                        VersionDocument: false,
                        DocumentID: mainCard.ID,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: historyChangeFieldsDocumentListName,
                      body: { ID: 0 },
                      bodyArr: historyFieldsCardUpdate,
                    }),
                  ];
                }
                // Меняем привязку уведомлений версии на основу
                if (notificationsVersionCard.length > 0) {
                  let notificationsCardUpdate: any = [];
                  notificationsVersionCard.forEach((notification: any) => {
                    notificationsCardUpdate = [
                      ...notificationsCardUpdate,
                      {
                        ID: notification.ID,
                        VersionDocument: null,
                      },
                    ];
                  });
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: notificationsListName,
                      body: { ID: 0 },
                      bodyArr: notificationsCardUpdate,
                    }),
                  ];
                }
                //Меняем согласованную версию на актуальную карточку
                if (version && Object.keys(version).length > 0) {
                  versionByMainArr = [
                    ...versionByMainArr,
                    updateItemRequest({
                      listName: myDocumentsListName,
                      body: {
                        ID: mainCard.ID,
                        Code: version.Code,
                        Index: version.Index,
                        Path: version.Path,
                        Title: version.Title,
                        Equipments: version.Equipments,
                        Lines: version.Lines,
                        Collection: version.Collection.get_lookupId(),
                        Critical: version.Critical,
                        DateForRevision: version.DateForRevision,
                        Department: version.Department.get_lookupId(),
                        DocType: version.DocType.get_lookupId(),
                        Process: version.Process.get_lookupId(),
                        PublicationDate: version.PublicationDate,
                        ResponsibleForRevision:
                          version.ResponsibleForRevision.get_email().toLowerCase(),
                        Sector: version.Sector.get_lookupId(),
                        Status: version.Status.get_lookupId(),
                        AuthorEmail: version.AuthorEmail.toLowerCase(),
                        ResponsibleForRevisionEmail:
                          version.ResponsibleForRevision.get_email().toLowerCase(),
                        Ver: version.Ver,
                        WorkPlaces: version.WorkPlaces && version.WorkPlaces.length > 0 && version.WorkPlaces.map(place => place.get_lookupId()) || [],
                        Created: version.Created
                      },
                    }),
                  ];
                }
                Promise.all(versionByMainArr).then((results: any) => {
                  const workPlacesIds = version.WorkPlaces && version.WorkPlaces.length > 0 && version.WorkPlaces.map(place => place.get_lookupId()) || [];
                  if (workPlacesIds && workPlacesIds.length > 0) {
                    getItemsRequest({ listName: notificationsCardListName, filters: { Document: mainCard.ID, NotificationType: notificationStatuses.familiarization, Read: false } }).then((results) => {
                      const notificationsIds = [...results.items.filter(item => item.Title.indexOf('Отклонено') === -1).map((item) => {
                        return { ID: item.ID }
                      })];
                      const idsForEmails = notificationsIds.map((item) => item.ID);
                      getItemsRequest({ listName: emailQueueListName, filters: { NotificationID: idsForEmails } }).then(results => {
                        const emailIds = [...results.items.map((item) => {
                          return { ID: item.ID }
                        })];
                        deleteItemRequest({ listName: emailQueueListName, ID: 0, Ids: emailIds }).then(() => {
                          deleteItemRequest({ listName: notificationsCardListName, ID: 0, Ids: notificationsIds }).then(() => {
                            getItemsRequest({ listName: MDWorkstationListName, filters: { ID: workPlacesIds } }).then((results) => {
                              addItemRequest({
                                listName: notificationIdsListName,
                                body: { Title: "Ознакомление" },
                                updateReducer: false,
                              }).then((notificationID) => {
                                const workPlaces = [...results.items];
                                let usersData: any = [];
                                workPlaces.forEach(place => {
                                  if (place.User && Array.isArray(place.User) && place.User.length > 0) {
                                    place.User.forEach((user: any) => {
                                      let displayName = user.get_metadata &&
                                        (user.get_metadata().DisplayName || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                                          ((user.get_metadata()["UserProfileProperties"].find(
                                            (item: any) => item.Key === "PreferredNameRus"
                                          ) &&
                                            user.get_metadata()["UserProfileProperties"].find(
                                              (item: any) => item.Key === "PreferredNameRus"
                                            )?.["Value"]) ||
                                            (user.get_metadata()["UserProfileProperties"].find(
                                              (item: any) => item.Key === "PreferredName"
                                            ) &&
                                              user.get_metadata()["UserProfileProperties"].find(
                                                (item: any) => item.Key === "PreferredName"
                                              )?.["Value"]))));
                                      if (displayName.split(" ").length === 3) {
                                        displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]
                                          }`;
                                      }
                                      usersData = [...usersData, {
                                        email: user.get_email().toLowerCase(),
                                        name: displayName,
                                        personalNumber: user.get_metadata && (user.get_metadata().EmployeeNumber || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                                          (user.get_metadata()["UserProfileProperties"].find(
                                            (item: any) => item.Key === "abiPersonnelNumber"
                                          )?.["Value"] ||
                                            user.get_metadata()["UserProfileProperties"].find(
                                              (item: any) => item.Key === "UserName"
                                            )?.["Value"])))
                                      }]
                                    });
                                  }
                                });
                                let dataNotificationsArr: any = [];
                                _.uniqWith(usersData, _.isEqual).map(user => {
                                  const days = Number(
                                    repeatEmails
                                      .find((param: any) => param.Key === "auditDateDefault")
                                    ["Value"].trim(),
                                  );
                                  dataNotificationsArr = [...dataNotificationsArr, {
                                    Title: "Уведомление " + notificationID,
                                    NotificationID: notificationID,
                                    Employee: user.email.toLowerCase(),
                                    EmployeeEmail: user.email.toLowerCase(),
                                    Document: mainCard.ID,
                                    DocumentCode: `${version.Code}.${version.Index}`,
                                    ReviewDate: moment().add(days, 'days').toDate(),
                                    AuthorComment: "",
                                    NotificationType: notificationStatuses.familiarization,
                                    AuthorEmail: "supply.portal@abinbevefes.com",
                                  }];
                                });
                                requests = [...requests, addItemRequest({ listName: notificationsCardListName, body: dataNotificationsArr[0], bodyArr: dataNotificationsArr })];
                                Promise.all(requests).then(() => {
                                  requests = [];
                                  let dataEmailNotificationArr: any = [];
                                  getItemsRequest({ listName: notificationsCardListName, filters: { Document: mainCard.ID, NotificationType: notificationStatuses.familiarization } }).then((results) => {
                                    const notifications = [...results.items];
                                    _.uniqWith(usersData, _.isEqual).map(user => {
                                      const minutes = Number(
                                        repeatEmails
                                          .find((param: any) => param.Key === "audit")
                                        ["Value"].trim(),
                                      );
                                      const days = Number(
                                        repeatEmails
                                          .find((param: any) => param.Key === "auditDateDefault")
                                        ["Value"].trim(),
                                      );
                                      const dateSendEmailsArr = [
                                        moment(new Date()).clone().subtract(12, "hours").toDate(),
                                        moment(new Date()).clone().add(minutes, "m").toDate(),
                                      ];
                                      dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                                        dataEmailNotificationArr = [
                                          ...dataEmailNotificationArr,
                                          sendEmail({
                                            Body: `Здравствуйте ${user['name']} (${user['personalNumber']}),<br/><br/>Прочитайте следующий (-е) документ (-ы) и подтвердите факт ознакомления с документом (-ами):<br/><br/>${`<a href="${siteUrl}/dashboard/1?documentCard=${mainCard.ID}">${version.Title
                                              }</a>`}<br/><br/>Срок ознакомления: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                                              }>${moment().add(Number(days), 'd').format(
                                                "DD.MM.YYYY",
                                              )}</span>`,
                                            DateToBeSentAt: date,
                                            Title: "Мои документы | Ознакомление с документами",
                                            Subject: "Мои документы | Ознакомление с документами",
                                            Recepients: user.email.toLowerCase(),
                                            CheckDoc: String(mainCard.ID),
                                            NotificationID: notifications.filter(item => item.EmployeeEmail.toLowerCase() === user.email).map(item => item.ID)[0],
                                            RepeatAt: (idxDate === 1 && minutes) || 0,
                                          })
                                        ];
                                      });
                                    });
                                    requests = [...requests, ...dataEmailNotificationArr];
                                    Promise.all(requests).then(() => {
                                      navigate(`/dashboard/1?documentCard=${mainCard.ID}`);
                                      navigate(0);
                                    });
                                  });
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  } else {
                    navigate(`/dashboard/1?documentCard=${mainCard.ID}`);
                    navigate(0);
                  }
                });
              });
            });
          });
        } else {
          if (!dataSend["nextGroup"] && dataSend['workPlacesIds'] && dataSend['workPlacesIds'].length > 0) {
            getItemsRequest({ listName: notificationsCardListName, filters: { Document: card.ID, NotificationType: notificationStatuses.familiarization, Read: false } }).then((results) => {
              const notificationsIds = [...results.items.filter(item => item.Title.indexOf('Отклонено') === -1).map((item) => {
                return { ID: item.ID }
              })];
              const idsForEmails = notificationsIds.map((item) => item.ID);
              getItemsRequest({ listName: emailQueueListName, filters: { NotificationID: idsForEmails } }).then(results => {
                const emailIds = [...results.items.map((item) => {
                  return { ID: item.ID }
                })];
                deleteItemRequest({ listName: emailQueueListName, ID: 0, Ids: emailIds }).then(() => {
                  deleteItemRequest({ listName: notificationsCardListName, ID: 0, Ids: notificationsIds }).then(() => {
                    getItemsRequest({ listName: MDWorkstationListName, filters: { ID: dataSend['workPlacesIds'] } }).then((results) => {
                      addItemRequest({
                        listName: notificationIdsListName,
                        body: { Title: "Ознакомление" },
                        updateReducer: false,
                      }).then((notificationID) => {
                        const workPlaces = [...results.items];
                        let usersData: any = [];
                        workPlaces.forEach(place => {
                          if (place.User && Array.isArray(place.User) && place.User.length > 0) {
                            place.User.forEach((user: any) => {
                              let displayName = user.get_metadata &&
                                (user.get_metadata().DisplayName || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                                  ((user.get_metadata()["UserProfileProperties"].find(
                                    (item: any) => item.Key === "PreferredNameRus"
                                  ) &&
                                    user.get_metadata()["UserProfileProperties"].find(
                                      (item: any) => item.Key === "PreferredNameRus"
                                    )?.["Value"]) ||
                                    (user.get_metadata()["UserProfileProperties"].find(
                                      (item: any) => item.Key === "PreferredName"
                                    ) &&
                                      user.get_metadata()["UserProfileProperties"].find(
                                        (item: any) => item.Key === "PreferredName"
                                      )?.["Value"]))));
                              if (displayName.split(" ").length === 3) {
                                displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]
                                  }`;
                              }
                              usersData = [...usersData, {
                                email: user.get_email().toLowerCase(),
                                name: displayName,
                                personalNumber: user.get_metadata && (user.get_metadata().EmployeeNumber || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                                  (user.get_metadata()["UserProfileProperties"].find(
                                    (item: any) => item.Key === "abiPersonnelNumber"
                                  )?.["Value"] ||
                                    user.get_metadata()["UserProfileProperties"].find(
                                      (item: any) => item.Key === "UserName"
                                    )?.["Value"])))
                              }]
                            });
                          }
                        });
                        let dataNotificationsArr: any = [];
                        _.uniqWith(usersData, _.isEqual).map(user => {
                          const days = Number(
                            repeatEmails
                              .find((param: any) => param.Key === "auditDateDefault")
                            ["Value"].trim(),
                          );
                          dataNotificationsArr = [...dataNotificationsArr, {
                            Title: "Уведомление " + notificationID,
                            NotificationID: notificationID,
                            Employee: user.email.toLowerCase(),
                            EmployeeEmail: user.email.toLowerCase(),
                            Document: card.ID,
                            DocumentCode: `${card.Code}.${card.Index}`,
                            ReviewDate: moment().add(days, 'days').toDate(),
                            AuthorComment: "",
                            NotificationType: notificationStatuses.familiarization,
                            AuthorEmail: "supply.portal@abinbevefes.com",
                          }];
                        });
                        requests = [...requests, addItemRequest({ listName: notificationsCardListName, body: dataNotificationsArr[0], bodyArr: dataNotificationsArr })];
                        Promise.all(requests).then(() => {
                          requests = [];
                          getItemsRequest({ listName: notificationsCardListName, filters: { Document: card.ID, NotificationType: notificationStatuses.familiarization } }).then((results) => {
                            const notifications = [...results.items];
                            let dataEmailNotificationArr: any = [];
                            _.uniqWith(usersData, _.isEqual).map(user => {
                              const minutes = Number(
                                repeatEmails
                                  .find((param: any) => param.Key === "audit")
                                ["Value"].trim(),
                              );
                              const days = Number(
                                repeatEmails
                                  .find((param: any) => param.Key === "auditDateDefault")
                                ["Value"].trim(),
                              );
                              const dateSendEmailsArr = [
                                moment(new Date()).clone().subtract(12, "hours").toDate(),
                                moment(new Date()).clone().add(minutes, "m").toDate(),
                              ];
                              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                                dataEmailNotificationArr = [
                                  ...dataEmailNotificationArr,
                                  sendEmail({
                                    Body: `Здравствуйте ${user['name']} (${user['personalNumber']}),<br/><br/>Прочитайте следующий (-е) документ (-ы) и подтвердите факт ознакомления с документом (-ами):<br/><br/>${`<a href="${siteUrl}/dashboard/1?documentCard=${card.ID}">${card.Title
                                      }</a>`}<br/><br/>Срок ознакомления: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                                      }>${moment().add(Number(days), 'd').format(
                                        "DD.MM.YYYY",
                                      )}</span>`,
                                    DateToBeSentAt: date,
                                    Title: "Мои документы | Ознакомление с документами",
                                    Subject: "Мои документы | Ознакомление с документами",
                                    Recepients: user.email.toLowerCase(),
                                    CheckDoc: String(versionView && card.MainDocument.get_lookupId() || card.ID),
                                    NotificationID: notifications.filter(item => item.EmployeeEmail.toLowerCase() === user.email).map(item => item.ID)[0],
                                    RepeatAt: (idxDate === 1 && minutes) || 0,
                                  })
                                ];
                              });
                            });
                            requests = [...requests, ...dataEmailNotificationArr];
                            Promise.all(requests).then(values => {
                              dataSend.reRender();
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          } else {
            Promise.all(requests).then(values => {
              dataSend.reRender();
            });
          }
        }
      }
      if (type === "updateMultiApproved") {
        console.log("Выполняется промежуточное согласование");
        /*if (dataSend["historyCardUpdate"]) {
          dataSend["historyCardUpdate"]["Comment"] = comment;
          requests = [...requests, updateItemRequest({ listName: historyByDocumentListName, body: dataSend["historyCardUpdate"] })];
        }*/
        if (dataSend["historyFieldsCardAdd"]) {
          dataSend["historyFieldsCardAdd"]["Comment"] = comment;
          requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: dataSend["historyFieldsCardAdd"] })];
        }
        Promise.all(requests).then(values => {
          dataSend.reRender();
        });
        //dataSend.reRender();
      }
      if (type === "archive") {
        let dataApproversCard: any = [],
          dataHistoryCard: any = [],
          historyFields: any = {},
          dataNotificationCard: any = [];
        dataApproversCard = [
          ...dataApproversCard,
          {
            Title: `Approver card # ${dataSend["updateCard"]["ID"]}`,
            Approvers: [currentUser.email],
            Document: dataSend["updateCard"]["ID"],
            VersionDocument: false,
            Group: docApprovers.Creater, // Список Approvers - Создатель
            Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирован, Отправлен на согласование
          },
        ];
        dataHistoryCard = [
          ...dataHistoryCard,
          {
            Title: `History card # ${dataSend["updateCard"]["ID"]}`,
            Comment: comment,
            VersionDocument: false,
            Approvers: [currentUser.email],
            DocumentID: dataSend["updateCard"]["ID"],
            ApprovalGroup: docApprovers.Creater, // Список Approvers - Создатель
            Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирован, Отправлен на согласование
          },
        ];
        historyFields = {
          Title: `History fields card # ${dataSend["updateCard"]["ID"]}`,
          DocumentID: dataSend["updateCard"]["ID"],
          VersionDocument: false,
          Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирован, Отправлен на согласование
          Comment: comment,
        };
        Object.keys(dataSend["new_approvers"]).map((key: string, idx: number) => {
          const people: { avatar: string; label: string; value: string }[] =
            dataSend["new_approvers"][key];
          let sendPeople: string[] = [];
          people.map((user) => {
            if (user.value) {
              sendPeople = [...sendPeople, user.value.toLowerCase()];
            }
          });
          const groupID =
            approversList.filter((item: any) => item.Code === key).length > 0 &&
            approversList.filter((item: any) => item.Code === key)[0]["ID"];
          if (checkApprovers(groupID, approversDependencies)) {
            if (sendPeople.length > 0) {
              sendPeople.forEach((email: any) => {
                dataNotificationCard = [
                  ...dataNotificationCard,
                  {
                    Title: `Согласовать # ${dataSend["updateCard"]["ID"]}`,
                    ReviewDate: moment(new Date())
                      .add(
                        Number(
                          repeatEmails
                            .find(
                              (param: any) => param.Key === "documentsApproveDays"
                            )
                          ["Value"].trim()
                        ),
                        "days"
                      )
                      .toDate(),
                    DocumentCode: `${dataSend["updateCard"]["Code"]}.${dataSend["updateCard"]["Index"]}`,
                    Document: dataSend["updateCard"]["ID"],
                    NotificationType: notificationStatuses.approval, // Согласовать
                    Employee: email.toLowerCase(),
                    EmployeeEmail: email.toLowerCase(),
                    AuthorEmail: currentUser.email.toLowerCase(),
                    Completed: new Date(),
                  },
                ];
              });
              if (emailsSender) {
                let emailsHanleArr: any = [];
                const minutes = Number(
                  repeatEmails
                    .find((param: any) => param.Key === "documentApprove")
                  ["Value"].trim()
                );
                const dateSendEmailsArr = [
                  moment(new Date()).clone().subtract(12, "hours").toDate(),
                  moment(new Date()).clone().add(minutes, "m").toDate(),
                ];
                dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                  sendPeople.forEach((email: any) => {
                    const emailBody = {
                      Body: `Здравствуйте ${users[email.toLowerCase()] &&
                        users[email.toLowerCase()]["displayName"]
                        },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${dataSend["updateCard"]["ID"]
                        }">${dataSend["updateCard"]["Title"]
                        }</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                        }>${moment(new Date())
                          .add(
                            Number(
                              repeatEmails
                                .find(
                                  (param: any) => param.Key === "documentsApproveDays"
                                )
                              ["Value"].trim()
                            ),
                            "days"
                          )
                          .format("DD.MM.YYYY")}</span>`,
                      DateToBeSentAt: date,
                      Title: "Мои Документы | Согласование документа",
                      Subject: "Мои Документы | Согласование документа",
                      Recepients: email,
                      CheckDoc: String(versionView && card.MainDocument.get_lookupId() || card.ID),
                      RepeatAt: (idxDate === 1 && minutes) || 0,
                    };
                    emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                  });
                });
                requests = [...requests, ...emailsHanleArr];
              }
            }
          }
          dataApproversCard = [
            ...dataApproversCard,
            {
              Title: `Approver card # ${dataSend["updateCard"]["ID"]}`,
              Approvers: sendPeople,
              Document: dataSend["updateCard"]["ID"],
              Group: groupID,
              Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
              Queue: checkApprovers(groupID, approversDependencies), // В зависимости от коллекции руководитель или безопасность
            },
          ];
          dataHistoryCard = [
            ...dataHistoryCard,
            {
              Title: `History card # ${dataSend["updateCard"]["ID"]}`,
              Comment: "",
              Approvers: sendPeople,
              DocumentID: dataSend["updateCard"]["ID"],
              ApprovalGroup: groupID,
              Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
            },
          ];
        });
        requests = [...requests, ...[
          addItemRequest({
            listName: approversCardDocumentListName,
            bodyArr: dataApproversCard,
            body: dataApproversCard[0],
          }),
          addItemRequest({
            listName: historyChangeFieldsDocumentListName,
            body: historyFields,
          }),
          addItemRequest({
            listName: historyByDocumentListName,
            bodyArr: dataHistoryCard,
            body: dataHistoryCard[0],
          }),
          updateItemRequest({
            listName: myDocumentsListName,
            body: dataSend["updateCard"],
          }),
        ]];
        if (dataNotificationCard.length > 0) {
          requests = [...requests, addItemRequest({ listName: notificationsListName, body: dataNotificationCard[0], bodyArr: dataNotificationCard })];
        }
        Promise.all(requests).then((results) => {
          navigate(`/dashboard/1`);
          navigate(0);
        });
      }
    }
    if (type === "draft") {
      dataSend["historyFieldsCardAdd"]["Comment"] = comment;
      if (
        dataSend["removeItemsApproversCardDocument"] &&
        dataSend["removeItemsApproversCardDocument"].length > 0
      ) {
        requests = [...requests, deleteItemRequest({ listName: approversCardDocumentListName, ID: 0, Ids: dataSend["removeItemsApproversCardDocument"] })]
      }
      requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: dataSend["historyFieldsCardAdd"] })]
      Promise.all(requests).then(values => {
        const EquipmentsListNew = dataSend['draftData']['EquipmentsListNew'];
        const fileDraftData = dataSend['draftData']['File'];
        delete dataSend["draftData"]["EquipmentsListOld"];
        delete dataSend["draftData"]["EquipmentsListNew"];
        delete dataSend["draftData"]["File"];
        addItemRequest({ listName: versionsByDocumentListName, body: dataSend["draftData"] }).then((idAddVersionCard) => {
          let dataApproversCard: any = [],
            dataHistoryCard: any = [];
          dataApproversCard = [
            ...dataApproversCard,
            {
              Title: `Approve card version # ${idAddVersionCard}`,
              Approvers: (currentUser.email && [currentUser.email]) || [],
              Document: idAddVersionCard,
              VersionDocument: true,
              order: 0,
              Group: docApprovers.Creater, // Список Approvers - Создатель
              Statuses: [docStatuses.edited, docStatuses.sendApproval], //Список Statuses - Изменен, Отправлен на согласование
            },
          ];
          dataHistoryCard = [
            ...dataHistoryCard,
            {
              Title: `History card version # ${idAddVersionCard}`,
              DocumentID: idAddVersionCard,
              Approvers: (currentUser.email && [currentUser.email]) || [],
              ApprovalGroup: docApprovers.Creater,
              Comment: comment,
              order: 0,
              VersionDocument: true,
              JSONChangesFields: JSON.stringify(dataSend['changesFieldValue']),
              Statuses: [docStatuses.edited, docStatuses.sendApproval], // Изменен, Отправлен на согласование
            },
          ];

          let notificationPeople: any = [];

          Object.keys(dataSend['new_approvers']).map((key: string, idx: number) => {
            const people: { avatar: string; label: string; value: string }[] =
              dataSend['new_approvers'][key];
            let sendPeople: string[] = [];
            people.map((user) => {
              if (user.value) {
                sendPeople = [...sendPeople, user.value.toLowerCase()];
              }
            });
            const groupID =
              approversList.filter((item: any) => item.Code === key).length > 0 &&
              approversList.filter((item: any) => item.Code === key)[0]["ID"];
            const order =
              (approversList.filter((item: any) => item.Code === key).length > 0 &&
                approversList.filter((item: any) => item.Code === key)[0][
                "SortColumn"
                ]) ||
              0;
            if (checkApprovers(groupID, approversDependencies)) {
              notificationPeople = [...sendPeople];
            }
            console.log(" ===> groupID: ", groupID);
            console.log(" ===> approversDependencies: ", approversDependencies);
            dataApproversCard = [
              ...dataApproversCard,
              {
                Title: `Approve card version # ${idAddVersionCard}`,
                Approvers: sendPeople,
                Document: idAddVersionCard,
                order: order,
                Group: groupID,
                VersionDocument: true,
                Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
                Queue: checkApprovers(groupID, approversDependencies), // В зависимости от коллекции руководитель или безопасность
                MultiApprove: setMultiApprove(groupID, approversDependencies),
              },
            ];

            dataHistoryCard = [
              ...dataHistoryCard,
              {
                Title: `History card version # ${idAddVersionCard}`,
                Comment: "",
                order: order,
                Approvers: sendPeople,
                DocumentID: idAddVersionCard,
                VersionDocument: true,
                ApprovalGroup: groupID,
                Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
              },
            ];
          });

          dataApproversCard.sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          dataHistoryCard.sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          const dataHistoryCardSend = dataHistoryCard.map((item: any) => {
            delete item.order;
            return { ...item };
          });

          const dataApproversCardSend = dataApproversCard.map((item: any) => {
            delete item.order;
            return { ...item };
          });

          const historyFieldsCardAdd = {
            Title: `History fields card version # ${idAddVersionCard}`,
            DocumentID: idAddVersionCard,
            Approvers: [currentUser.email],
            Comment: comment,
            VersionDocument: true,
            JSONChangesFields: JSON.stringify(dataSend['changesFieldValue']),
            Statuses: [docStatuses.edited, docStatuses.sendApproval], // Изменен, Отправлен на согласование
          };
          requests = [];
          requests = [...requests, addItemRequest({ listName: approversCardDocumentListName, body: dataApproversCardSend[0], bodyArr: dataApproversCardSend })];
          requests = [...requests, addItemRequest({ listName: historyByDocumentListName, body: dataHistoryCardSend[0], bodyArr: dataHistoryCardSend })];
          requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: historyFieldsCardAdd })];
          if (notificationPeople.length > 0) {
            let notificationData: any = [];
            notificationPeople.forEach((approverEmail: string) => {
              notificationData = [
                ...notificationData,
                {
                  Title: `Согласовать версию # ${idAddVersionCard}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        repeatEmails
                          .find(
                            (param: any) =>
                              param.Key === "documentsApproveDays",
                          )
                        ["Value"].trim(),
                      ),
                      "days",
                    )
                    .toDate(),
                  AuthorComment: comment,
                  DocumentCode: `${dataSend['draftData'].Code}.${dataSend['draftData'].Index}`,
                  Document: Number(dataSend['draftData'].MainDocument),
                  NotificationType: notificationStatuses.approval, // Согласовать
                  Employee: approverEmail.toLowerCase(),
                  EmployeeEmail: approverEmail.toLowerCase(),
                  VersionDocument: idAddVersionCard,
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                },
              ];
            });
            if (emailsSender) {
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim(),
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                notificationPeople.forEach((email: any) => {
                  const emailBody = {
                    Body: `Здравствуйте ${users[email.toLowerCase()] &&
                      users[email.toLowerCase()]["displayName"]
                      },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${dataSend['draftData'].MainDocument
                      }&version=${idAddVersionCard}">${dataSend['draftData'].Title
                      }</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                      }>${moment(new Date())
                        .add(
                          Number(
                            repeatEmails
                              .find(
                                (param: any) =>
                                  param.Key === "documentsApproveDays",
                              )
                            ["Value"].trim(),
                          ),
                          "days",
                        )
                        .format("DD.MM.YYYY")}</span>`,
                    DateToBeSentAt: date,
                    Title: "Мои Документы | Согласование документа",
                    Subject: "Мои Документы | Согласование документа",
                    Recepients: email,
                    CheckDoc: String(dataSend['draftData'].MainDocument),
                    RepeatAt: (idxDate === 1 && minutes) || 0,
                  };
                  emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                });
              });
              requests = [...requests, ...emailsHanleArr];
            }
            requests = [...requests, addItemRequest({ listName: notificationsListName, body: notificationData[0], bodyArr: notificationData })];
            if (EquipmentsListNew && Array.isArray(EquipmentsListNew) && EquipmentsListNew.length > 0) {
              let sendDataEquipments: any = [];
              for (
                let i = 0;
                i < EquipmentsListNew.length;
                i++
              ) {
                sendDataEquipments = [
                  ...sendDataEquipments,
                  {
                    Title: `Document card #${idAddVersionCard}`,
                    Line:
                      EquipmentsListNew[i]["Line"] &&
                      EquipmentsListNew[i]["Line"]["id"],
                    Equipment:
                      EquipmentsListNew[i]["SAP"] &&
                      EquipmentsListNew[i]["SAP"]["ID"],
                    Document: idAddVersionCard,
                    VersionDocument: true,
                  },
                ];
              }
              if (sendDataEquipments.length > 0) {
                requests = [...requests, addItemRequest({ listName: equipmentsByDocumentListName, body: sendDataEquipments[0], bodyArr: sendDataEquipments })];
              }
            }
            if (Array.isArray(fileDraftData) && fileDraftData.length > 0 && fileDraftData[0].hasOwnProperty("FileLeafRef")) {
              requests = [...requests, fetch(fileDraftData[0]["FileRef"]).then((r) =>
                r.blob().then((blob) => {
                  let newname = fileDraftData[0].FileLeafRef.substring(
                    0,
                    fileDraftData[0].FileLeafRef.lastIndexOf("."),
                  ).toLowerCase();
                  let extension = fileDraftData[0].FileLeafRef.substring(
                    fileDraftData[0].FileLeafRef.lastIndexOf("."),
                  ).toLowerCase();
                  let fullName = newname + extension;
                  const file = new File([blob], `${fullName}`, {
                    type: blob.type,
                  });
                  return uploadFile(
                    file,
                    documentByCardFilesLibName,
                    MDDocumentsFiles.idFolder,
                    MDDocumentsFiles.apiStrapi,
                    MDDocumentsFiles.createElemInStrapi,
                    dataSend["draftData"]["Title"],
                  ).then((objUploadFile: any) => {
                    return updateFile(
                      documentByCardFilesLibName,
                      {
                        CardID: idAddVersionCard,
                        ID: objUploadFile.id,
                        VersionDocument: true,
                      },
                      MDDocumentsFiles.apiStrapi,
                      {
                        CardID: idAddVersionCard,
                        id: objUploadFile.id,
                        VersionDocument: true,
                      }
                    );
                  });
                }),
              )];
            } else {
              requests = [...requests, uploadFile(
                fileDraftData,
                documentByCardFilesLibName,
                MDDocumentsFiles.idFolder,
                MDDocumentsFiles.apiStrapi,
                MDDocumentsFiles.createElemInStrapi,
                dataSend["draftData"]["Title"]
              ).then((objUploadFile: any) => {
                return updateFile(
                  documentByCardFilesLibName,
                  {
                    CardID: idAddVersionCard,
                    ID: objUploadFile.id,
                    VersionDocument: true,
                  },
                  MDDocumentsFiles.apiStrapi,
                  {
                    CardID: idAddVersionCard,
                    id: objUploadFile.id,
                    VersionDocument: true,
                  }
                );
              })]
            }
            Promise.all(requests).then(values => {
              navigate(`/dashboard/1`);
              navigate(0);
            });
          }
        });
      });
    }
    if (type !== "approve" && type !== "draft" && type !== 'archive' && type !== "updateMultiApproved" && type !== "sendMultiApproved") {
      Promise.all(requests).then(values => {
        dataSend.reRender();
      });
    }
  };

  return (
    <DialogComponent open={open} toggleDialog={dialogToggle}>
      <div className="md:min-w-[600px]">
        <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">
          {((dataSend["type"] === "agreement" ||
            dataSend["type"] === "archive" ||
            dataSend["type"] === "draft") &&
            "Отправка на согласование") ||
            "Подтвердите действие"}
        </span>
        {(dataSend["type"] === "approve" || dataSend["type"] === "reject" || dataSend["type"] === "updateMultiApproved") && (
          <span className="flex items-center text-[16px] leading-[22px] mb-[38px]">
            <input
              className="h-5 w-5 rounded border-gray-300 text-[#012169]"
              onChange={() => setConfirm(!confirm)}
              type="checkbox"
              checked={confirm}
            />
            &nbsp;&nbsp;
            {(dataSend["type"] === "approve" || dataSend["type"] === "updateMultiApproved") && (
              <span>
                Я&nbsp;прочитал(-а) и&nbsp;подтверждаю факт согласования
                документа
              </span>
            )}
            {dataSend["type"] === "reject" && (
              <span>
                Я&nbsp;прочитал(-а) и&nbsp;подтверждаю факт отклонения документа
              </span>
            )}
          </span>
        )}
        {dataSend["type"] === "modification" && (
          <span className="flex items-center text-[16px] leading-[22px] mb-[38px]">
            Вы внесли изменения в документ и возвращаете документ
            <br />
            автору на доработку. Пожалуйста, оставьте комментарий
          </span>
        )}
        <div id="comment_card_form" className="relative w-full pt-6 mb-5">
          <label htmlFor="comment_card" className="flex justify-between">
            <span className="text-sm font-medium leading-6 text-gray-900">
              Комментарий
            </span>
            {(dataSend["type"] === "modification" ||
              dataSend["type"] === "reject") && (
                <span className="text-[#BA0C2F]">*</span>
              )}
          </label>
          <div className="mt-2">
            <input
              id="comment_card"
              type="text"
              autoComplete="off"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Комментарий"
              className="block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white"
            />
          </div>
        </div>
        <div className="divide-y mb-[40px] h-px border-t" />
        <div className="flex justify-between">
          <Button
            classBg="btn-white"
            shadow={true}
            text="Отмена"
            open={open}
            setOpen={setOpen}
          />
          {((dataSend["type"] === "approve" || dataSend["type"] === "updateMultiApproved") && (
            <Button
              open={open}
              setOpen={setOpen}
              disabled={!confirm}
              classBg="btn-dark"
              customFunction={sendDataHandle}
              paramsCustomFunction={dataSend.type}
              text="Подтвердить"
            />
          )) ||
            (dataSend["type"] === "reject" && (
              <Button
                open={open}
                setOpen={setOpen}
                disabled={!confirm || !comment}
                classBg="btn-red"
                customFunction={sendDataHandle}
                paramsCustomFunction={dataSend.type}
                text="Подтвердить"
              />
            )) ||
            (dataSend["type"] === "modification" && (
              <Button
                open={open}
                setOpen={setOpen}
                disabled={!comment}
                classBg="btn-dark"
                customFunction={sendDataHandle}
                paramsCustomFunction={dataSend.type}
                text="Подтвердить"
              />
            )) ||
            ((dataSend["type"] === "agreement" ||
              dataSend["type"] === "archive" ||
              dataSend["type"] === "draft") && (
                <Button
                  open={open}
                  setOpen={setOpen}
                  classBg="btn-dark"
                  customFunction={sendDataHandle}
                  paramsCustomFunction={dataSend.type}
                  text="Отправить"
                />
              ))}
        </div>
      </div>
    </DialogComponent>
  );
};

export default ConfirmChangeStatusCardModal;
